<template>
  <div class="book book-container">
    <div class="book-wrapper">
      <div class="book-title" ref="title">
        <div class="book-title-page" v-if="$root.books && $root.books.length > 0">
          <h1>Error 404</h1>
          <h1>Book not available</h1>
          <router-link tag="h1" :to="{name: 'book', params:{bookId: $root.books[0].Id, stub: $root.books[0].Stub}}">Please navigate here</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Errorpage'
}
</script>

<style lang="scss">
    @import '../main';
</style>



// WEBPACK FOOTER //
// src/views/Error.vue